'use client'

// src/Divider/Divider.tsx
import { useId } from "react";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var Divider = ({ type = "default", repeat = 1, className }) => {
  const id = useId();
  switch (type) {
    case "zigzag":
      return /* @__PURE__ */ jsx("div", { className: twMerge("overflow-hidden", className), dir: "ltr", children: /* @__PURE__ */ jsxs(
        "svg",
        {
          className: "overflow-visible",
          width: "16",
          height: 11 * repeat,
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("pattern", { id, patternUnits: "userSpaceOnUse", width: "16", height: "11", children: /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.86 0L16 5.43V10.1L7.86 4.68L0 10.1V5.43L7.86 0Z",
                fill: "currentColor"
              }
            ) }) }),
            /* @__PURE__ */ jsx("rect", { width: "4000", height: 11 * repeat, fill: `url(#${id})` })
          ]
        }
      ) });
    case "waves":
      return /* @__PURE__ */ jsx("div", { className: twMerge("overflow-hidden", className), dir: "ltr", children: /* @__PURE__ */ jsxs(
        "svg",
        {
          className: "overflow-visible",
          width: "91",
          height: 12 * repeat,
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("pattern", { id, patternUnits: "userSpaceOnUse", width: "91", height: "12", children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M0 4.07C0 4.07 11.81 7.98 29.22 0V6.96C29.22 6.96 14.4 14.94 0 10.72V4.77",
                  fill: "currentColor"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M29.22 5.47C29.22 5.47 41.27 -2.63 61.09 0.88V7.85C61.09 7.85 49.1 3.55 29.22 11.95V5.47Z",
                  fill: "currentColor"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M61.09 4.07C61.09 4.07 72.9 7.98 90.3 0V6.96C90.3 6.96 75.49 14.94 61.09 10.72V4.77",
                  fill: "currentColor"
                }
              )
            ] }) }),
            /* @__PURE__ */ jsx("rect", { width: "4000", height: 12 * repeat, fill: `url(#${id})` })
          ]
        }
      ) });
    case "ticket_edges":
      return /* @__PURE__ */ jsx("div", { className: twMerge("overflow-hidden", className), dir: "ltr", children: /* @__PURE__ */ jsxs(
        "svg",
        {
          className: "overflow-visible",
          width: "29",
          height: 19 * repeat,
          viewBox: "0 0 29 19",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("pattern", { id, patternUnits: "userSpaceOnUse", width: "29", height: "19", children: /* @__PURE__ */ jsx(
              "path",
              {
                d: "M0 19V0H3.5C3.5 0 4 9.5 14.5 9.5C25 9.5 26 0 26 0H29V19H0Z",
                fill: "currentColor"
              }
            ) }) }),
            /* @__PURE__ */ jsx("rect", { width: "4000", height: 19 * repeat, fill: `url(#${id})` })
          ]
        }
      ) });
    default:
      return /* @__PURE__ */ jsx("hr", { className: twMerge("border-paper", className) });
  }
};
var Divider_default = Divider;

export {
  Divider_default
};
//# sourceMappingURL=chunk-6GFY3I3S.mjs.map